import throttle from '../utilities/throttle.js';
import Emitter from '../core/emitter.js'

import resolveConfig from 'tailwindcss/resolveConfig'
import customConfig from '../../../tailwind.config.js'
const tailwindConfig = resolveConfig(customConfig)

class Viewport {
    constructor(){
        this.onResize();

        this._onResize = this.onResize.bind(this)

        window.addEventListener('resize', throttle(this._onResize, 100), false);
        window.addEventListener('orientationchange', throttle(this._onResize, 1000), true);
    }

    onResize() {
        this.width = window.innerWidth
        this.height = window.innerHeight

        this.isTouch = "ontouchstart" in window;
        this.isMobile = this.width < 768
        this.isTablet = this.width <= 1024

        if (this.isTouch) {
			if (this.oldWidth !== this.width) {
				this.oldWidth = this.width
				this.svh = this.height
			}
		} else {
			this.svh = this.height
		}

		this.oldWidth = this.width

		document.documentElement.style.setProperty('--vh', `${this.height * 0.01}px`)
        document.body.classList.toggle('has-hover', window.matchMedia('(hover: hover)').matches);

        this.updateBreakpoint()

        Emitter.emit('resize')
    }

    updateBreakpoint() {
        const breakpoint = this.getBreakpoint();
        if (breakpoint !== this.breakpoint) Emitter.emit('break', breakpoint)
        this.breakpoint = breakpoint
    }

    get _sortedScreen() {
        const screenEntries = Object.entries(
          tailwindConfig.theme.screens 
        )
    
        const screens = screenEntries.map(([name, breakpoint]) => [
          name,
          parseInt(breakpoint),
        ])
        return screens.sort((a, b) => (b[1]) - (a[1]))
    }
    
    getBreakpoint() {
        const screens = this._sortedScreen

        const match = screens.find(([, breakpoint]) => {
            return breakpoint <= this.width
        })

        return match ? match[0] : 'mobile'
    }
    
    from(breakpointName) {
        const screens = this._sortedScreen
        const breakpoint = screens.find(
            ([name]) => name === breakpointName
        )
        return breakpoint ? breakpoint[1] <= this.width : false
    }
      
    
    to(breakpointName) {
        const screens = this._sortedScreen
        const breakpoint = screens.find(
            ([name]) => name === breakpointName
        )
        return breakpoint ? breakpoint[1] > this.width : false
    }
      
}

const storeViewport = new Viewport;

export default storeViewport;
